import React, {FC, useCallback, useState} from "react";
import EChartsReact from "echarts-for-react";
import { trafficLight } from "../../theme";
import { IDamsList, ISummaryCriticalHazards } from "../../types/types";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    Accordion,
    AccordionSummary, ClickAwayListener,
    Divider, Grow, IconButton, MenuItem, Drawer,
    Paper, Popper, Toolbar, Grid, Tooltip
} from "@material-ui/core";
import { CSVLink, CSVDownload } from "react-csv";
import GetAppIcon from '@material-ui/icons/GetApp';
import NotesIcon from '@material-ui/icons/Notes';


import {toPng} from "html-to-image";
import downloadjs from "downloadjs";

const useStyles = makeStyles({

    grid: {
        display: 'grid',
        gridTemplateColumns: 'max-content repeat(6,1fr)',
        padding: '10px 15% 10px 15%',
        justifyContent: 'center',

    },

    item: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px solid lightgrey',
        fontSize: '12px',
        padding: '0px 2px',



    },
    item2: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        width: '17px',
        height: '17px',
        margin: '2px 0px',
        '&:hover': {
            transform: 'scale(1.0)',
            boxShadow: '0px 0px 5px 0px black',

        }
    },
    title: {
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',

        fontSize: '12px',
        padding: '0px 2px',

    },

    label: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: '1px solid grey',
        borderRight: '1px solid grey',
        borderBottom: '1px solid grey',
        fontSize: '12px',
        padding: '10px 5px',
        // writingMode: 'vertical-rl',
        // WebkitTransform: 'rotate(180deg)',




    },


    label2: {
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        borderTop: '1px solid black',
        padding: '10px 0px',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    overlap: {
        gridArea: '1 / 1 / 10 / 10',
        position: 'relative',
        ZIndex: '1',
    }

});

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
    },
}))(Tooltip);



interface IFMChartProps {
    controlMeasures: any[][]
}


const HeatMapTableCM2: FC<IFMChartProps> = ({ controlMeasures }) => {

    const classes = useStyles();

    const subgroups: string[] = ['Reasonably Practicable', 'Reasonably Practicable (Tentative)', 'Not Reasonably Practicable (Tentative)', 'Not Reasonably Practicable', 'Cannot Determine at this Time'];
    const count_data = controlMeasures.map(dam => {
        return dam.map(d => {
            // if d is an array
            if (Array.isArray(d)) {
                return d[1]
            }
            else {
                return d
            }
        })
    })

    const handleCaptureClick = useCallback(() => {

        const pricingTableElmt = document.querySelector<HTMLElement>('.cma-table')
        if (!pricingTableElmt) return;
        toPng(pricingTableElmt, {pixelRatio: 20, cacheBust: true})
            .then((dataUrl: any) => {
                downloadjs(dataUrl, 'Control_measure_assessment.png');
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])

    const csvData = [['dam name', 'societal impact', ...subgroups], ...count_data]


    const setColor = (level: any, def: any) => {

        if (def === 0) {
            return 'white'
        }

        if (level === 1) {
            return trafficLight.cmorange
        }
        if (level === 2) {
            return trafficLight.cmyellow
        }
        if (level === 3) {
            return trafficLight.bgreen
        }
        if (level === 4) {
            return trafficLight.cmgreen
        }
        if (level === 5) {
            return trafficLight.grey
        }

    }

    const setName = (level: any) => {

        if (level === 1) {
            return 'Very Strong'
        }
        if (level === 2) {
            return 'Strong'
        }
        if (level === 3) {
            return 'Weak'
        }
        if (level === 4) {
            return 'Very Weak'
        }
        if (level === 5) {
            return 'Undefined'
        }
    }


    return (
        <>
            <div style={{ padding: "10px" }}>
                <Paper variant={"outlined"}  className={'table-section.' + ' cma-table'}>
                    <Grid container>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            <p style={{ fontSize: "20px", position: 'relative', top: '-10px' }}><strong>Reasonably Practicable assessment of additional controls <br></br> by failure modes</strong></p>
                            <p style={{ fontSize: "12px", position: 'relative', top: '-20px' }}>Number of control measures</p>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton aria-label="download" onClick={handleCaptureClick}>
                                <GetAppIcon/>
                            </IconButton>
                            <CSVLink data={csvData} filename={"Control_measure_assessment.csv"}>
                                <IconButton aria-label="download">
                                    <NotesIcon />
                                </IconButton>
                            </CSVLink>
                        </Grid>
                    </Grid>
                    <div className={classes.grid}>
                    <div className={classes.title} > </div>
                        <div className={classes.label} style={{borderLeft:'1px solid black'}} > Societal risk (live/year) </div>
                        {
                            subgroups.map(subgroup => {
                                return <div className={classes.label}>{subgroup}</div>
                            })
                        }
                        {
                            controlMeasures.map(dam => {

                                let dam_name = ""

                                const element = dam.map((d, index) => {

                                    let left = ""
                                    let right = "0px solid black"

                                    if (index === 1) {
                                        left = "1px solid black"
                                        right = "1px solid black"
                                    }

                                    if (index === 6) {
                                        right = "1px solid black"
                                    }

                                    if (index === 0) {
                                        dam_name = d
                                        return <div className={classes.title}>{d}</div>
                                    }
                                    if (index === 1) {
                                        return (<div className={classes.item} style={{ borderLeft: left, borderRight: right, color: setColor(6, d[1]) }} >
                                            {d}
                                        </div>)
                                    }
                                    else {
                                        return (
                                            <LightTooltip title={
                                                <div>
                                                    <b>{dam_name}</b> <br /> {setName(d)}
                                                </div>
                                            }>
                                                <div className={classes.item} style={{ borderLeft: left, borderRight: right, color: setColor(6, d[1]) }} >
                                                    {d[1] !== 0
                                                        ? <div className={classes.item2} style={{ backgroundColor: setColor(d[0], d[1]) }}>{d[1]}</div>
                                                        : ""}
                                                </div>
                                            </LightTooltip>)

                                    }
                                })

                                return element
                            })
                        }
                       


                    </div>
                </Paper>
            </div>



        </>

    )

}


export default HeatMapTableCM2;